import { Tag } from 'antd';
import styled from 'styled-components';

export const Capsules = styled.div`
  margin-bottom: 30px;
  > p {
    padding-left: 20px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding-left: 0px;
      width: 100%;
    }
  }
`;

export const Capsule = styled(Tag)`
  border-radius: 18px;
  padding: 7px 10px;
  font-size: ${props => props.theme.fontSize.primary};
  margin-bottom: 12px;
  & .anticon-close {
    font-size: ${props => props.theme.fontSize.primary} !important;
    vertical-align: ${props => props.isSafari ? 'middle' : 'unset'};
    padding-left: 10px;
    @media only screen and (min-width: 320px) and (max-width: 767px) {
      padding-left: 0;
      margin-left: 8px;
    }
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const CapuseleController = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inline-block;
  width: ${props => (props.mobileView ? '90%' : 'auto')};
  vertical-align: middle;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.greyishBrown};
`;
